import { useContext } from "react";
import { z } from "zod";

import { LdoAuthContext } from "@nens/ldo/auth-v1";
import { useParsedQuery } from "@nens/react-query-utils";
import { combineUrlAndParams } from "@nens/shared-utils";

import { API_BASE_URL } from "../constants";
import { dateSchema } from "../dates";
import { Scenario } from "../domain/scenario";
import { LdoPaginated, paginatedSchema } from "../pagination";

import { reviewSchema, scenarioStatusSchema } from "./scenarios";

const historyItemSchema = z.object({
  scenario_id: z.number(),
  updated_at: dateSchema,
  updated_by: z.object({
    id: z.string(),
    name: z.string(),
  }),
  meta: z.object({}),
  review: reviewSchema.nullable(),
  meta_version: z.number(),
  status: scenarioStatusSchema,
});

export type HistoryItem = z.infer<typeof historyItemSchema>;

const historyListSchema = paginatedSchema(historyItemSchema);

export type HistoryList = LdoPaginated<HistoryItem>;

export function useScenarioHistory(scenario: Scenario, params = {}) {
  const url = combineUrlAndParams(`${API_BASE_URL}/scenarios/${scenario.id}/history`, params);
  const { apiFetchFunction, tenantId } = useContext(LdoAuthContext);
  return useParsedQuery<HistoryList>(
    [tenantId, "ldo-api-v1", "scenarios", "history", url],
    () => apiFetchFunction(url),
    (json: unknown) => {
      const apiHistory = historyListSchema.parse(json);
      return apiHistory;
    }
  );
}
